import React, { useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";   // added by ChatGPT on 2025-11-24 14:00 – Header needed for store
import PublicStorePage from "./pages/PublicStorePage";
import OtpLoginPage from "./pages/OtpLoginPage";
import ProductUploadPage from "./pages/ProductUploadPage";
import ShopPage from "./pages/ShopPage";
import AddProduct from "./pages/AddProduct";
import AdminOrdersPage from "./pages/AdminOrdersPage";
import SelfProductAdminForm from "./pages/SelfProductAdminForm";
import "./index.css";
import PaymentSuccess from "./pages/PaymentSuccess";
import BagPage from "./pages/BagPage"; // added by ChatGPT on 2025-11-24 15:10 – Bag page for multi-product checkout

function App() {
  const location = useLocation();

  // added by ChatGPT on 2025-11-24 14:00 – store-wide search state
  const [searchQuery, setSearchQuery] = useState("");

  // added by ChatGPT on 2025-11-24 15:10 – global bag/cart state
  const [bagItems, setBagItems] = useState([]);

 const handleAddToBag = (item) => {
  setBagItems((prev) => [...prev, item]);
};

  // added by ChatGPT on 2025-11-24 15:10 – remove product from bag
  const handleRemoveFromBag = (productId) => {
    setBagItems((prev) => prev.filter((item) => item._id !== productId));
  };

  return (
    <div className="app-root">
      <div className="app-background" />

      <div className="app-container">

        {/* Sidebar hidden on /store and /bag (public pages) */}
        {/* {location.pathname !== "/store" && <Sidebar />} */}
        {/* fixed/updated by ChatGPT on 2025-11-24 15:10 – hide sidebar on bag page also for public shop layout */}
        {location.pathname !== "/store" &&
        location.pathname !== "/bag" &&
        location.pathname !== "/payment-success" && (
          <Sidebar />
      )}

        <main className="content-wrapper">
          <Routes>
            <Route path="/" element={<Navigate to="/store" replace />} />

            {/* OLD */}
            {/* <Route path="/store" element={<PublicStorePage />} /> */}

            {/* updated by ChatGPT on 2025-11-24 14:00 – Added Header + search bridge + bag count */}
            <Route
              path="/store"
              element={
                <>
                  <Header
                    onSearchChange={setSearchQuery}
                    bagCount={bagItems.length}
                  />
                  <PublicStorePage
                    searchQuery={searchQuery}
                    onAddToBag={handleAddToBag}
                  />
                </>
              }
            />

            {/* added by ChatGPT on 2025-11-24 15:10 – Bag page with Header */}
            <Route
              path="/bag"
              element={
                <>
                  <Header
                    onSearchChange={setSearchQuery}
                    bagCount={bagItems.length}
                  />
                  <BagPage
                    items={bagItems}
                    onRemoveFromBag={handleRemoveFromBag}
                  />
                </>
              }
            />

            <Route path="/login" element={<OtpLoginPage />} />
            <Route path="/upload" element={<ProductUploadPage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route
                path="/payment-success"
                element={
                  <>
                    <Header onSearchChange={setSearchQuery} bagCount={bagItems.length} />
                    <PaymentSuccess />
                  </>
                }
              />
            <Route path="/orders" element={<AdminOrdersPage />} />
            <Route path="/product-types" element={<SelfProductAdminForm />} />
            <Route path="/add-product" element={<AddProduct />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default App;
